import React, { useContext, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';

import { Context } from '../../context/provider';

import CloseIcon from '../../../../icons/close.svg';

import CardStackAnimation from '../stackView/components/CardStackAnimation';
import TimelineAnimation from '../stackView/components/TimelineAnimation';

import StyledStackView from '../stackView/stackView.style';
import StyledTransition from './transition.style';

const Transition = ({ introCard }) => {
  const videoRef = useRef(null);
  const { setIsTransitionActive } = useContext(Context);

  const handleComplete = () => {
    setIsTransitionActive(false);
    window.sessionStorage.setItem('archive-transition', 'true');
  };

  const handleEventStartAnimation = () => {
    if (videoRef.currenet) {
      videoRef.current.muted = true;
      videoRef.current.play();
    }
  };

  useEffect(() => {
    if (window.sessionStorage.getItem('archive-transition') === 'true') {
      setIsTransitionActive(false);
    }
  }, []);

  return (
    <StyledTransition
      className="archive-transition"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4, ease: 'linear' }}
    >
      <button
        className="archive-transition__close"
        type="button"
        onClick={() => setIsTransitionActive(false)}
      >
        <CloseIcon />
      </button>

      <motion.div
        className="archive-transition__background"
        initial={{
          top: '65%',
          opacity: 0
        }}
        animate={{
          ease: 'easeIn',
          top: '0%',
          opacity: 1,
          transition: { duration: 0.5 }
        }}
      >
        <video
          ref={videoRef}
          autoPlay
          muted
          playsInline
          loop
          src="/static/video/archive-transition/futurium-archive-background-square-withFade-compressed.mp4"
          className="archive-transition__media"
          onCanPlay={handleEventStartAnimation}
          poster="/static/images/video-poster/transition-video-poster.jpg"
        />
      </motion.div>
      <StyledStackView>
        <motion.div
          className="stack-view__inner"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.4, ease: 'linear' }}
        >
          <div className="stack-view__content">
            <CardStackAnimation introCard={introCard} className="stack-view__card-stack" />
          </div>

          <motion.div
            className="stack-view__timeline"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6, duration: 0.4, ease: 'linear' }}
          >
            <TimelineAnimation onAnimationComplete={handleComplete} />
          </motion.div>
        </motion.div>
      </StyledStackView>
    </StyledTransition>
  );
};

Transition.propTypes = {
  introCard: PropTypes.shape({
    copy: PropTypes.string.isRequired,
    headline: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired
  }).isRequired
};

export default Transition;
